import request from '@/utils/request'


export function getInfo(data) {
  return request({
    url: 'goods/getInfo',
    method: 'get',
    params: data
  })
}

export function toSeek(data) {
  return request({
    url: 'goods/submitSeek',
    method: 'post',
    data: data
  })
}